// extracted by mini-css-extract-plugin
export var content = "_re-1";
export var fullScreen = "_re-0";